import { Anchor, Box, Container, Group, Text } from '@mantine/core';

import { ColorSchemeToggle } from '@/components/molecules';

export function CopyrightNotice() {
  return (
    <Box component="footer" py="xl">
      <Container size="lg">
        {' '}
        <Group justify="space-between" align="center" gap="sm" wrap="wrap">
          <Group gap="md">
            <Anchor href="/privacy" size="sm" c="dimmed">
              Privacy
            </Anchor>
            <Anchor href="/terms" size="sm" c="dimmed">
              Terms
            </Anchor>
            <Anchor href="/pricing" size="sm" c="dimmed">
              Pricing
            </Anchor>
          </Group>
          <ColorSchemeToggle />

          <Text size="xs" c="dimmed" ta="center">
            © {new Date().getFullYear()} Goldseam AI Consulting Ltd
          </Text>
        </Group>
      </Container>
    </Box>
  );
}
